var _defs, _path, _path2, _polygon, _polygon2, _polygon3, _path3, _path4, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArgenta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: white;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.2,275.6h6.9c4.1,0,19-.2,19-13.6s-3.9-13-15.3-13h-10.6v26.5ZM204.1,309.2l-22.8-32.2h-.2v32.2h-10.1v-69.5h21.3c9.7,0,14.7,2.3,18.4,5.8,4.2,4.4,6.5,10.3,6.3,16.4,0,18.4-15.3,21.3-19.8,21.3l19.4,25.9h-12.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.9,257.2c-2.9-3.2-8.7-9.5-18.8-9.5s-25.5,12.4-25.5,27c0,14.4,11.3,26.2,25.6,26.6,1.9,0,17.2-.2,23.8-17.3h-32.2v-9.3h43.6c0,19.6-15.9,35.5-35.5,35.5s-35.5-15.9-35.5-35.5,15.4-36.3,35.2-36.3c13,0,24.9,7.3,31,18.8h-11.8Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "292.8 309.2 292.8 239.7 330 239.7 330 249 302.9 249 302.9 269.5 330 269.5 330 278.8 302.9 278.8 302.9 299.9 330 299.9 330 309.2 292.8 309.2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "381 309.2 346.9 255.5 346.7 255.5 346.7 309.2 336.6 309.2 336.6 239.7 347.7 239.7 381.2 292.6 381.4 292.6 381.4 239.7 391.5 239.7 391.5 309.2 381 309.2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "406.8 309.2 406.8 249 393.5 249 393.5 239.7 430.1 239.7 430.1 249 416.8 249 416.8 309.2 406.8 309.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444.5,278.8v-25.7l33,25.5-33,.2ZM444.5,239.6h-10.9v70.2h10.9v-21.2h45.9l27.3,21.1h15.5l-88.7-70.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.5,278.8h-33c0-.1,33-25.7,33-25.7v25.7ZM155.5,239.6l-88.8,70.2h15.5l27.3-21.1h45.9v21.2h10.9v-70.3h-10.9Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "279.4 129.3 302.4 129.3 251.9 169.4 251.9 151.1 279.4 129.3"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "336.7 218.5 313.7 218.5 364.3 178.4 364.3 196.6 336.7 218.5"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "336.7 129.3 349 139 264.1 206.3 251.9 196.6 251.9 174.2 308.5 129.3 336.7 129.3"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "352 141.5 364.3 151.1 364.3 173.6 307.6 218.5 279.4 218.5 267.1 208.8 352 141.5"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "316 123.4 344.2 101.1 396.9 101.1 368.8 123.4 316 123.4"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "309.9 94.3 315.6 89.8 315.6 118.9 309.9 123.4 309.9 94.3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgenta);
export default __webpack_public_path__ + "static/media/argenta.f3cecd446f23fdf9fa8cab91f03d4e42.svg";
export { ForwardRef as ReactComponent };